var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-module',_vm._b({staticClass:"zg-item-section"},'zg-module',_vm.moduleProps,false),[_vm._t("sub-title",null,{"slot":"sub-title"}),_vm._v(" "),_c('div',{class:['items', {
      'items--three': _vm.items.length === 3,
      'items--two': _vm.items.length === 2,
      'items--one': _vm.items.length === 1,
    }]},_vm._l((_vm.items),function(item,index){return _c('zg-item-solo',_vm._b({key:item.contentId || index,staticClass:"item"},'zg-item-solo',item,false))}),1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }